import Photo1 from '../../images/mission_impossible_1.jpg';
import Photo2 from '../../images/mission_impossible_2.jpg';

type Props = {};

export default function Page2({}: Props) {
	return (
		<>
			<h1 className="text-5xl font-medium border-b-2 border-b-customBlue w-fit pb-2">Mission: Impossible The Final Reckoning</h1>
			<div className="flex gap-10 w-full items-center justify-center h-[500px]">
				<div className="h-full w-fit rounded-xl overflow-hidden">
					<img src={Photo1} className="h-full w-full object-contain" alt="img_impossible" />
				</div>
				<div className="h-full w-fit rounded-xl overflow-hidden">
					<img src={Photo2} className="h-full w-full object-contain" alt="img_impossible" />
				</div>
			</div>

			<div className="flex flex-col">
				<h3 className="text-3xl mb-3">Dostępne opcje (ten tydzień)</h3>
				<span className="text-xl">{'->'} Środa 20:15, Galeria Mokotów</span>
				<span className="text-xl">{'->'} Czwartek 20:15, Galeria Mokotów</span>
			</div>
		</>
	);
}
